import { render } from "./ViewSpecifics.vue?vue&type=template&id=bdece2ac&scoped=true"
import script from "./ViewSpecifics.vue?vue&type=script&lang=js"
export * from "./ViewSpecifics.vue?vue&type=script&lang=js"

import "./ViewSpecifics.vue?vue&type=style&index=0&id=bdece2ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdece2ac"]])

export default __exports__